import { render, staticRenderFns } from "./SalaryStatistics.vue?vue&type=template&id=3d39ed56&"
import script from "./SalaryStatistics.vue?vue&type=script&lang=js&"
export * from "./SalaryStatistics.vue?vue&type=script&lang=js&"
import style0 from "./SalaryStatistics.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports